// ObjectWithNumericKeys accepts {"4": "description 4", "84": "description 84"} but not { "four": "description 4" }
type StringNumericKeys = `${number}`;
type ObjectWithNumericKeys = { [key in StringNumericKeys]: string };

export class DynamicValidationRules {
  min?: number | Date | string;

  max?: number | Date | string;
}

export function limparCamposOcultos(camposSpec: DynamicFieldSpec[], camposAux: Record<string, any>): void {
  for (const campo of camposSpec) {
    const regra = campo.visivelSe;
    if (!regra?.campo) continue;

    if (!camposAux[regra.campo]) delete camposAux[campo.nome];
  }
}

export function filtrarCamposAtivos(campos: DynamicFieldSpec[] | null | undefined): DynamicFieldSpec[] {
  return (campos ?? []).filter((c) => c.ativo !== false);
}

function normalize(str: string) {
  str = str.replace(/^[0-9]+/, '');
  {
    const palavras = str.split(' ');
    for (const i in palavras) palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1);
    str = palavras.join('');
  }
  str = str
    // eslint-disable-next-line
    .normalize('NFD')
    .replace(/[ \u0300-\u036f]/g, '');
  str = str.replace(/[^A-Za-z0-9]/g, ' ');
  {
    const palavras = str.split(' ');
    for (const i in palavras) palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1);
    str = palavras.join('');
  }
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export class DynamicFieldSpec {
  nome: string = 'undefined';

  label: string = this.nome;

  parentClass: string | undefined = undefined;

  tipo: 'dict' | 'dict?' | 'int' | 'int?' | 'float' | 'float?' | 'bool' | 'string' | 'string?' | 'date' | 'date?' | 'time' | 'time?' | 'datetime' | 'datetime?' = 'string';

  // ["Amarelo"] ou {"0": "Amarelo"} ou 51 (onde o dicionário remoto 51 possui amarelo) são equivalentes
  dict?: string[] | ObjectWithNumericKeys | number;

  regras?: DynamicValidationRules;

  descricao?: string;

  visivelSe?: { campo: string };

  ativo?: boolean;

  constructor(params: Partial<DynamicFieldSpec>) {
    Object.assign(this, params);
    if (!this.nome || this.nome == 'undefined') this.nome = normalize(this.label);
  }
}

export class DynamicFormSpec {
  unidadeMedidaQuantidade: string = '';
  tipo: string = '';
  campos: DynamicFieldSpec[] = [];
  parametrosFinanceiros: boolean = false;

  constructor(params: Partial<DynamicFormSpec>) {
    Object.assign(this, params);
  }
}

export const ControleFinanceiro = {
  SEM_CONTROLE: { value: 'Sem Controle', label: 'Sem Controle' },
  CALCULO_VALOR_UNITARIO: { value: 'Cálculo Valor Unitário', label: 'Cálculo Valor Unitário' },
  VALOR_NO_RECEBIMENTO: { value: 'Valor no Recebimento', label: 'Valor no Recebimento' }
};

export class ObservacaoConfig {
  texto: string = '';
  ativo: boolean = true;
  ordem: number = 1;

  constructor(params?: Partial<ObservacaoConfig>) {
    if (params) Object.assign(this, params);
  }
}

export class UtlTipoFornecimentoConfiguracao {
  produto: DynamicFormSpec;
  lote: DynamicFormSpec;
  recebimento: DynamicFormSpec;
  recebimentoItem?: DynamicFormSpec;
  aplicacao?: DynamicFormSpec;
  fornecedorObra: DynamicFormSpec;
  contatos: DynamicFormSpec;
  controleFinanceiro: string;
  permiteEditarNumeracaoEnsaio: boolean;
  permiteLevantamentoEstoque: boolean;
  notaFiscalOpcional: boolean;
  placaOpcional: boolean;
  uploadNotaFiscalOpcional: boolean;
  horarioObrigatorioCaminhoes: boolean;
  empreiteiroTipoFornecimentoId: number | null;
  observacoes: ObservacaoConfig[];

  constructor() {
    this.produto = new DynamicFormSpec({ campos: [] });
    this.lote = new DynamicFormSpec({ campos: [] });
    this.recebimento = new DynamicFormSpec({ campos: [] });
    this.recebimentoItem = new DynamicFormSpec({ campos: [] });
    this.aplicacao = new DynamicFormSpec({ campos: [] });
    this.fornecedorObra = new DynamicFormSpec({ campos: [] });
    this.contatos = new DynamicFormSpec({ campos: [] });
    this.controleFinanceiro = ControleFinanceiro.SEM_CONTROLE.value;
    this.permiteEditarNumeracaoEnsaio = false;
    this.permiteLevantamentoEstoque = false;
    this.notaFiscalOpcional = false;
    this.placaOpcional = false;
    this.uploadNotaFiscalOpcional = false;
    this.horarioObrigatorioCaminhoes = false;
    this.empreiteiroTipoFornecimentoId = null;
    this.observacoes = [];
  }
}

export class UtlTipoFornecimentoModel {
  utlTipoFornecimentoId: number | null = null;
  descricao: string = '';
  configuracao: UtlTipoFornecimentoConfiguracao = new UtlTipoFornecimentoConfiguracao();
}

export class UtlTipoFornecimentoModelPadrao {
  utlTipoFornecimentoId: number | null = null;
  descricao: string = '';
  configuracao: string = '';
  rastreavelPorLote: boolean = false;
  controleEstoque: boolean = false;
  ativo: boolean = true;
}
